export function ensureHttp(url: string): string {
	return url.startsWith("http") ? url : `https://${url}`;
}
